export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15103.6229d09d.jpg";